
import { Inspect } from "@/script/apps/inspect/entity/InspectEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { InspectService } from "@/script/apps/inspect/service/InspectService";

@Options({})
export default class InspectList extends BaseList {
  private queryEntity: Inspect = {};

  private dataList: Inspect[] = [];

  private service = new InspectService();

  private dateRange: string[] = [];

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_inspect",
      "/ins/inspect",
      "/ins/inspect",
      this.service
    );
    data.statesName = "ins-order-state";
    return data;
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    this.queryParam.pager!.sorters = [];
    this.queryParam.pager!.sorters.push({
      prop: "createTime",
      sortField: "create_time",
      sortMode: "desc",
    });
    this.dateRange = [];
    return this.queryEntity;
  }

  public initParam() {
    const param = this.$route.query;
    if (param.state) {
      this.queryEntity.state = String(param.state);
    }
  }

  public beforeLoadList() {
    if (this.queryEntity.state === "") {
      this.queryEntity.state = null;
    }
    if (this.dateRange && this.dateRange.length > 0) {
      this.dateRange[1] = this.dateRange[1].replace("00:00:00", "23:59:59");
      this.queryParam.extendMap = {
        beginTime: this.dateRange[0],
        endTime: this.dateRange[1],
      };
    } else {
      this.queryParam.extendMap = {};
    }
  }

  public afterLoadList(data: any): void {
    const currDataList: Inspect[] = data.list as Inspect[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
  }
}
